import { createSelector } from '@reduxjs/toolkit';
import { RootInitialState } from 'core/common/store/rootReducer';
import {
  getIsAppleMobile,
  getIsApplePaySupported,
  getIsMobileDevice,
  getIsTestingEnv,
  getPlatform,
  getProject,
  getSystemLanguage,
} from 'core/common/store/system';
import { getPaymentCardBank, getPaymentCardBrand } from 'core/payments/store/selectors';
import {
  getEmailDomain,
  getGender,
  getUserLocation,
  getUserType,
  getUtmCampaign,
  getUtmContent,
  getUtmCookies,
  getUtmCreoGroup,
  getUtmSource,
} from 'core/user/store/selectors';
import { FeatureFlagsAttributes } from '../entities';

export const getFeatureFlagsConfig = createSelector(
  [
    (state: RootInitialState) => state.featureFlags.config,
    (state: RootInitialState) => state.featureFlags.loadingStatus,
  ],
  (config, loadingStatus) => ({ config, loadingStatus }),
);

export const getFeatures = (state: RootInitialState) => {
  return state.featureFlags.features || state.featureFlags.experiments;
};

export const getFeatureFlagsAttributes = createSelector(
  [
    getGender,
    getIsTestingEnv,
    getSystemLanguage,
    getUserLocation,
    getIsApplePaySupported,
    getIsAppleMobile,
    getIsMobileDevice,
    getUtmSource,
    getPlatform,
    getUtmContent,
    getUtmCookies,
    getUtmCampaign,
    getUtmCreoGroup,
    getPaymentCardBank,
    getPaymentCardBrand,
    getProject,
    getEmailDomain,
    getUserType,
  ],
  (
    gender,
    isTestingEnv,
    language,
    userLocation,
    isApplePaySupported,
    isAppleMobile,
    isMobileDevice,
    utmSource,
    platform,
    utmContent,
    utmCookies,
    utmCampaign,
    utmCreoGroup,
    paymentCardBank,
    paymentCardBrand,
    project,
    emailDomain,
    userType,
  ): FeatureFlagsAttributes => {
    return {
      gender,
      isTestingEnv,
      language,
      isAppleMobile,
      isApplePaySupported,
      isMobileDevice,
      locale: userLocation.locale,
      utmSource,
      platform,
      utmContent,
      utmCookies,
      utmCampaign,
      utmCreoGroup,
      paymentCardBank,
      paymentCardBrand,
      project,
      emailDomain,
      userType,
    };
  },
);
